import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TextareaComponent } from './textarea.component';

@NgModule({
  imports: [
    CommonModule,
    TextareaComponent
  ],
  declarations: [],
  exports: [
    TextareaComponent
  ]
})
export class TextareaModule {}
